import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LiveSource } from '../../../domain/live-sources';

@Component({
  selector: 'evrideo-live-sources-grid',
  templateUrl: './live-sources-grid.component.html',
  styleUrls: ['./live-sources-grid.component.scss'],
})
export class LiveSourcesGridComponent {
  @Input() sources: LiveSource[] = [];
  @Output() deleteSource = new EventEmitter<string>();

  onDelete(id: string): void {
    this.deleteSource.emit(id);
  }
}
